import FormattedMessage from 'I18n/components/FormattedMessage';
import Section from 'settings-ui-lib/components/Section';
import AccountOptionsContainer from '../containers/AccountOptionsContainer';
import { useIsGlobalHomeEligible } from '../hooks/useGlobalHome';
import WorkingHours from './WorkingHours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccountDefaults = () => {
  const {
    isEligible,
    error
  } = useIsGlobalHomeEligible();
  // Only want to show the account options if endpoint returned that the user is not eligible for global home
  const showAccountOptions = !isEligible && !error;
  return /*#__PURE__*/_jsxs(Section, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.defaults.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.defaults.subtitle"
    }),
    inlineSize: "500px",
    children: [showAccountOptions && /*#__PURE__*/_jsx(AccountOptionsContainer, {}), /*#__PURE__*/_jsx(WorkingHours, {})]
  });
};
export default AccountDefaults;